import i18next from 'i18next';

i18next.addResources('es', 'home', {
  title: 'Base de datos del Plan Maestro (PM-CBC)',
  subtitle: 'Cartera de Proyectos y Acciones del Plan Maestro del Corredor Bioceánico de Capricornio: consulte, filtre y analice las iniciativas de los ocho territorios del Corredor',
  planMaestro: 'Plan Maestro',
  sourcesLabel: 'Fuentes del Plan Maestro',
  byCountry: 'Por país',
  byTerritory: 'Por territorio',
  byTheme: 'Por tema',
  bySubtheme: 'Por subtema',
  seeMore: 'Ver más',
  noActions: 'Esta fuente todavía no tiene proyectos ni acciones publicados.'
});

i18next.addResources('en', 'home', {
  title: 'Master Plan Database (PM-CBC)',
  subtitle: 'Portfolio of Projects and Actions of the Capricorn Bioceanic Corridor Master Plan: browse, filter and analyze the initiatives of the eight territories of the Corridor',
  planMaestro: 'Master Plan',
  sourcesLabel: 'Master Plan sources',
  byCountry: 'By country',
  byTerritory: 'By territory',
  byTheme: 'By theme',
  bySubtheme: 'By subtheme',
  seeMore: 'See more',
  noActions: 'This source has no published projects or actions yet.'
});

i18next.addResources('pt', 'home', {
  title: 'Base de dados do Plano Mestre (PM-CBC)',
  subtitle: 'Carteira de Projetos e Ações do Plano Mestre do Corredor Bioceânico de Capricórnio: consulte, filtre e analise as iniciativas dos oito territórios do Corredor',
  planMaestro: 'Plano Mestre',
  sourcesLabel: 'Fontes do Plano Mestre',
  byCountry: 'Por país',
  byTerritory: 'Por território',
  byTheme: 'Por tema',
  bySubtheme: 'Por subtema',
  seeMore: 'Ver mais',
  noActions: 'Esta fonte ainda não tem projetos nem ações publicados.'
});
